import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postTaskType = (
    token: string,
    backend: string,
    created_by_id: number,
    changed_by_id: number,
    type_title: string,
    description: string,
    icon = "",
) => {
    return fetch(
        `${getApiUrl(backend)}tasktypes`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                created_by_id,
                changed_by_id,
                type_title,
                description,
                icon,
            })
        }
    );
};

export default postTaskType;
